import { useState } from "react";
import OpenAI from "openai";
import { AnimatedRobot } from "../components/ui/loader/AnimatedRobot";
import gradient from "../../src/assets/svg/gradient.svg";
import { Textarea } from "../components/ui/loader/TextArea";
import DashboardLayout from "../layouts/Dashboardlayout";
import undo from "../../src/assets/svg/undo.svg";
import bg from "../../src/assets/svg/bg.svg";
import send from "../assets/svg/send.svg";
import copy from "../assets/svg/copy.svg";
import quillbot from "../assets/svg/quillbot.svg";
const openAi = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY, // Use env variables for security
  dangerouslyAllowBrowser: true,
});

const ImageGeneratorAI = () => {
  const initialState = {
    prompt: "",
    image: null,
    loading: false,
    showResults: false,
  };

  const [state, setState] = useState(initialState);
  const [prompt, setPrompt] = useState("");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const generateImage = async () => {
    if (!prompt) return;

    setLoading(true);
    setShowResults(true);
    try {
      const response = await openAi.images.generate({
        model: "dall-e-3",
        prompt,
        n: 1,
        size: "1024x1024",
      });

      setImage(response.data[0].url);
    } catch (error) {
      console.error("Error generating image:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUndo = () => {
    setState(initialState);
    setPrompt("");
    setImage(null);
    setLoading(false);
    setShowResults(false);
  };
  return (
    <DashboardLayout>
      <div
        className="h-screen w-full bg-cover bg-center flex flex-col  relative overflow-y-auto"

      >
        <img className="absolute right-0 top-0" src={gradient} />

        <div className=" w-full ">
          {!showResults && (
            <div className="lg:h-screen w-full bg-cover bg-center flex flex-col md:justify-center md:items-center relative">
              {" "}
              <img className="absolute right-0 top-0" src={gradient} />
              <div className="">
                <div className="flex flex-col justify-center items-center gap-4 text-center md:px-0 px-4">
                  <div className="w-[100px] h-[100px] quillbot rounded-full flex justify-center items-center">
                    <div className="w-16 h-16 rounded-full flex justify-center items-center bg-[white]/20 border border-[white]/10 drop-shadow-[0px_1.5px_4px_rgba(16,25,40,0.07)] backdrop-blur-[20px]">
                      <img
                        src={quillbot}
                        className="w-10 h-10"
                        alt="quillbot"
                      />
                    </div>
                  </div>
                  <h2 className="md:text-[48px] text-[36px] font-semibold bg md:leading-[60px] leading-[40px] mt-6">
                    Generate Image with AI
                  </h2>
                  <p className="text-[#F2F4F7] mt-4">
                    Transform your ideas into stunning visuals
                  </p>
                </div>

                <div className="relative w-full mt-10">
                  <div className="lg:w-[936px] w-full h-full relative ">
                    <div className="w-full md:h-[195px] h-[108px] rounded-[12px] bgt p-5 ">
                      <Textarea
                        placeholder="Enter your prompt"
                        className="w-full h-full"
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            generateImage();
                          }
                        }}
                      />
                    </div>

                    <div
                      onClick={generateImage}
                      disabled={!prompt || loading}
                      class=" cursor-pointer absolute bottom-5 right-5 w-12 h-12 rounded-full flex justify-center items-center border border-white/10 bg-white/10 shadow-[inset_0px_8px_12px_rgba(255,255,255,0.4),inset_0px_20px_30px_rgba(255,255,255,0.4),inset_0px_-10px_75px_rgba(255,255,255,0.2)] backdrop-blur-[30px]"
                    >
                      <img src={send} className="w-6 h-6" alt="send" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showResults && (
            <div className="flex flex-col w-full gap-10 md:p-10 p-6 md:mt-0 mt-[90px] ">
              <div className="flex justify-end">
                <button
                  onClick={handleUndo}
                  className=" bt w-[100px] h-[36px] px-[18px] flex items-center gap-2"
                >
                  <img src={undo} alt="undo" />
                  <h5 className="font-medium text-white">Undo</h5>
                </button>
              </div>
              <div className="w-full bg-black bgtt p-[22px] flex flex-col ">
                <h4 className="text-white ">Generate image with AI</h4>
                <div className="w-full bgt h-full overflow-hidden p-3 mt-5">
                  <Textarea
                    placeholder="Describe your issue"
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        generateImage();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="w-full  bgtt p-[22px] ">
                {loading ? (
                  <div className="flex justify-center items-center h-[400px]">
                    <div className="flex flex-col gap-4">
                      <AnimatedRobot />
                      <h5 className="text-[20px] font-medium text-white">
                        Generating Image ............
                      </h5>
                    </div>
                  </div>
                ) : image ? (
                  <img
                    src={image}
                    alt="Generated"
                    loading="lazy"
                    className="rounded-lg shadow-lg w-full h-full"
                  />
                ) : (
                  <p className="text-[#F2F4F7]">
                    Your generated image will appear here.
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ImageGeneratorAI;
